<template>
  <base-modal size="lg" hide-header hide-footer @close="$emit('close')">
    <div class="col-12" @click.stop="">
      <h3 class="editor-header">
          {{ $t('common.import_from_file') }}
      </h3>
      <div style="position: relative; height: 40vh; padding: .2em; text-align: left">
        <map-container
          ref="mapContainer"
          :find-user="false"
          @on-map-changed="mapChanged"
        />
      </div>
        <!-- Hidden file input -->
        <input
            type="file"
            class="d-none"
            id="photo"
            accept="gt, csv"
            @change="handleFileInput"
            ref="fileInput"
        />
      <div class="col-sm-12 p-2">
        <span class="span-title">{{ $t('street_lights.station') }}</span>
        <select
          id="lightStation"
          v-model="selectedStation"
          class="form-select form-select-sm"
        >
          <option value="">{{ $t('street_lights.select_station') }}</option>
          <option
            v-for="station in stations"
            :key="station.value"
            :value="station.value"
          >
            {{ station.text }}
          </option>
        </select>
      </div>

      <div class="col-12 text-end mt-2">
          <button
              type="button"
              class="btn btn-outline-primary form-button"
              @click="triggerFileInput"
          >
              {{ $t('import_file_wizard.import_file') }}
        </button>
        <button
          size="sm"
          class="btn btn-secondary form-button"
          :disabled="loading"
          @click.stop="$emit('close')"
        >
          {{ $t('common.close') }}
        </button>
        <button
          class="btn btn-success form-button"
          :disabled="loading || !importedCables || importedCables.length < 1 || !selectedStation"
          @click.stop="submitCables"
        >
          {{ $t('common.save') }}
        </button>
      </div>

      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </div>
  </base-modal>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import {mapHelper} from '../mixins/MapMixin'
import {cableHelper} from "@/components/mixins/CableMixin";
import MapContainer from "@/components/map/MapContainer";
import BaseModal from "@/components/BaseModal";
import {inject} from "vue";

export default {
    name: 'CableImporter',
    components: {BaseModal, MapContainer},
    mixins: [restApi, mapHelper, cableHelper],
    props: {
        user: {
            type: Object,
            default: null
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            importFile: null,
            importedCables: null,
            map: null,
            selectedStation: null,
            stations: []
        }
    },

    watch: {
        selectedStation: function () {
            if (this.importedCables) {
                this.setStationAndPurpose()
            }
        },
        importFile() {
            this.submitFile()
        }
    },

    mounted() {
        this.fetchStations()
    },

    methods: {
        handleFileInput(event) {
            const file = event.target.files[0]
            if (file) {
                this.importFile = file
            } else {
                this.importFile = null
            }
        },

        triggerFileInput() {
            // Trigger the file input to open the file dialog
            this.$nextTick(() => {
                const input = this.$refs.fileInput
                if (input) {
                    input.click()
                }
            })
        },
        setStationAndPurpose() {
            this.importedCables.forEach(cable => {
                cable.station = this.selectedStation ? {id: this.selectedStation } : null
                cable.purpose = this.PURPOSE_LIGHT
            })
        },
        mapChanged(map) {
            this.map = map
            if(this.getMapSettingsIn(['center'])){
                let center = this.getMapSettingsIn(['center'])
                this.map.zoomToPosition(center.lat, center.lng, this.map.getMapZoomLevel())
            }
        },
        submitFile() {
            this.hideCables()
            if (this.importFile) {
                let formData = new FormData()
                this.loading = true
                formData.append('importFile', this.importFile)
                this.restPostWithFile(this.cableImportUrl, {}, formData,
                    (response) => {
                        this.loading = false
                        this.importedCables = response
                        this.setStationAndPurpose()
                        this.drawCables()
                    }, this.fail
                )
            }
        },
        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },
        drawCables: function () {
            // Zoom to cables
            if (this.importedCables && this.importedCables.length > 0) {
                this.importedCables.forEach(function (cable, index) {
                    var points = cable.geometry.points.map(point => {
                        return {x: point[0], y: point[1]}
                    })
                    this.map.drawPolyLine(index+1, this.CABLE, points, this.getTypeColor(cable.type),
                        this.isDashed(cable.type), false, this.getWidth(cable.type))
                }, this)
                this.map.zoomToGroup(this.CABLE)
            }
        },
        hideCables: function () {
            if (this.map) {
                this.map.removeMapItemsByType(this.CABLE)
            }
        },
        submitCables() {
            if (this.importedCables && this.importedCables.length > 0) {
                this.restAdd(this.cableBulkUrl, this.importedCables,
                    () => {
                        this.loading = false
                        this.importFile = null
                        this.hideCables()
                        this.showAlert(this.$t('cables.import_successful'), 'success')
                    }, this.fail
                )
            }
        },
        fetchStations() {
            this.loading = true
            this.stations = []
            this.restFetch(this.powerStationUrl, this.handleSearch, () => {
                this.loading = false
            })
        },
        handleSearch: function (response) {
            if (response && response.data) {
                response.data.forEach(station => {
                    this.stations.push({value: station.id, text: station.id + ' ' + station.location_name})
                })
            }
            this.loading = false
        }
    }
}
</script>
